import React, { useEffect, useState } from 'react';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import HttpHelper from '../../service/httpService'
import moment from 'moment'
import { AiOutlineDelete } from "react-icons/ai";
import DashboardWrapper from './DashboardWrapper';
import { RxCross1 } from 'react-icons/rx';
import { AiOutlineEye } from 'react-icons/ai';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { hasAddPermission, hasDeletePermission, hasEditPermission, hasReadPermission, initilizeUserInfo } from "../../service/userService";

const SecurityObjectName = 'Website.PartnerContactInquiries';

const DashboardPartnerInquires = (props) => {

    const [hasReadPermissionUser, setHasReadPermissionUser] = useState('');
    const [hasAddPermissionUser, setHasAddPermissionUser] = useState('');
    const [hasEditPermissionUser, setHasEditPermissionUser] = useState('');
    const [hasDeletePermissionUser, setHasDeletePermissionUser] = useState('');

    const getAllPermission = () => {
        setHasReadPermissionUser(hasReadPermission(SecurityObjectName));
        setHasAddPermissionUser(hasAddPermission(SecurityObjectName));
        setHasEditPermissionUser(hasEditPermission(SecurityObjectName));
        setHasDeletePermissionUser(hasDeletePermission(SecurityObjectName));
    }

    const [loaderApi, setLoaderApi] = useState(false);

    const [progress, setProgress] = useState(0);
    const [PartnerContactInquires, setPartnerContactInquires] = useState({});
    const [imageContentShow, setImageContentShow] = useState('');
    const [showImgPopup, setShowImgPopup] = useState(false);

    const getPartnerContactInquiries = async () => {
        setLoaderApi(true);
        HttpHelper.get("PartnerInquiry").then((response) => {
            if (response.status == 200) {
                setPartnerContactInquires(response.data.data);
            } else {
                console.log(response.data.data);
            }
            setLoaderApi(false);
            getAllPermission();
        })
    }

    useEffect(() => {
        getPartnerContactInquiries();
    }, [])

    const deleteInquiry = async (inquiryId) => {
        swal("Are you sure, you want to delete this inquiry?", { buttons: ["Cancel", "Yes"] })
            .then(async (willDelete) => {
                if (willDelete) {
                    await HttpHelper.delete("PartnerInquiry/" + inquiryId).then((response) => {
                        if (response.status === 200) {
                            props.showToast('success', 'Inquiry delete successfully');
                            getPartnerContactInquiries();
                        }
                    })
                }
            });
    }
    const exportToExcel = () => {

        if (!PartnerContactInquires || PartnerContactInquires.length === 0) {
            props.showToast('warning', 'No data to export');
            return;
        }

     
        const excelData = PartnerContactInquires.map((item, index) => ({
            '#': index + 1,
            Name: `${item.firstName} ${item.lastName}`,
            Email: item.emailAddress,
            'Company Name': item.companyName,
            Address: `${item.streetName}, ${item.cityName}, ${item.countryName}`,
            'Created At': moment(item.createdAt).format("MMMM D YYYY, h:mm:ss A")
        }));

        
        const worksheet = XLSX.utils.json_to_sheet(excelData);

   
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Partner Inquiries');

        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
        });

        const file = new Blob([excelBuffer], {
            type: 'application/octet-stream'
        });

        saveAs(
            file,
            `Partner_Contact_Inquiries_${moment().format('YYYYMMDD_HHmmss')}.xlsx`
        );
    };


    return (
        <DashboardWrapper>
            <div className="DashboardWrapperChild">
                <Sidebar />
                <div className="contentWrapper">
                    <HeaderDashboard progress={progress} title="Partner Contact Inquiries" />
                    <div className="container-fluid mt-80 p-0">
                        <div className="row">


                            {hasAddPermissionUser == true && loaderApi == false ? <div className="col-md-12 mb-2 table-responsive">
                                <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign" style={{ minHeight: 'calc(100vh - 120px)' }}>
                                    <button
                                        onClick={exportToExcel}
                                        style={{
                                            fontSize: '14px',
                                            backgroundColor: '#014022',
                                            color: '#ffffff',
                                            border: 'none',
                                            padding: '6px 14px',
                                            fontWeight: '600',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Export to Excel
                                    </button>

                                    <div className="d-flex justify-content-end mb-2">
                                    </div>

                                    <table className="table tableCustomized table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    #
                                                </th>
                                                <th>
                                                    Name
                                                </th>
                                                <th>
                                                    Email
                                                </th>
                                                <th>
                                                    Company Name
                                                </th>
                                                <th>
                                                    Address
                                                </th>
                                                <th>
                                                    Created At
                                                </th>
                                                <th>
                                                    Actions
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                PartnerContactInquires.length > 0 ?
                                                    PartnerContactInquires.map((inquiry, index) => {
                                                        return (<>
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{inquiry.firstName + " " + inquiry.lastName}</td>
                                                                <td>{inquiry.emailAddress}</td>
                                                                <td>{inquiry.companyName}</td>
                                                                <td>{inquiry.streetName + ", " + inquiry.cityName + ", " + inquiry.countryName}</td>
                                                                <td>{moment(inquiry.createdAt).format("MMMM D YYYY, h:mm:ss A")}</td>
                                                                <td>
                                                                    <b onClick={() => {
                                                                        var contentGet = <><div className="contentWrapPopup">
                                                                            <div className="contentWrapPopupGrid">
                                                                                <label>Name :</label>
                                                                                <span>{inquiry.firstName + " " + inquiry.lastName}</span>
                                                                            </div>
                                                                            <div className="contentWrapPopupGrid">
                                                                                <label>Email :</label>
                                                                                <span>{inquiry.emailAddress}</span>
                                                                            </div>
                                                                            <div className="contentWrapPopupGrid">
                                                                                <label>Company Name :</label>
                                                                                <span>{inquiry.companyName}</span>
                                                                            </div>
                                                                            <div className="contentWrapPopupGrid">
                                                                                <label>Address :</label>
                                                                                <span>{inquiry.streetName + ", " + inquiry.cityName + ", " + inquiry.countryName}</span>
                                                                            </div>
                                                                            <div className="contentWrapPopupGrid">
                                                                                <label>Created At :</label>
                                                                                <span>{moment(inquiry.createdAt).format("MMMM D YYYY, h:mm:ss A")}</span>
                                                                            </div>
                                                                            <div className="contentWrapPopupGrid">
                                                                                <label>Business Phone :</label>
                                                                                <span>{inquiry.businessPhone}</span>
                                                                            </div>
                                                                            <div className="contentWrapPopupGrid">
                                                                                <label>Company Website :</label>
                                                                                <span>{inquiry.companyWebsite}</span>
                                                                            </div>
                                                                            <div className="contentWrapPopupGrid">
                                                                                <label>Partnership TimeFrame :</label>
                                                                                <span>{inquiry.partnershipTimeFrame}</span>
                                                                            </div>
                                                                            <div className="contentWrapPopupGrid">
                                                                                <label>Size Of Business :</label>
                                                                                <span>{inquiry.sizeOfBusiness}</span>
                                                                            </div>
                                                                            <div className="contentWrapPopupGrid">
                                                                                <label>Socio Economic Group :</label>
                                                                                <span>{inquiry.socioEconomicGroup}</span>
                                                                            </div>
                                                                            <div className="contentWrapPopupGrid">
                                                                                <label>Primary Naics Code" :</label>
                                                                                <span>{inquiry.primaryNaicsCode}</span>
                                                                            </div>
                                                                            <div className="contentWrapPopupGrid">
                                                                                <label>Nature Of Business :</label>
                                                                                <span>{inquiry.natureOfBusiness}</span>
                                                                            </div>
                                                                            <div className="contentWrapPopupGrid">
                                                                                <label>Description Of Idea :</label>
                                                                                <span>{inquiry.descriptionOfIdea}</span>
                                                                            </div>
                                                                        </div></>;
                                                                        setShowImgPopup(true);
                                                                        setImageContentShow(contentGet);
                                                                    }}><AiOutlineEye /></b>
                                                                    <AiOutlineDelete onClick={() => { deleteInquiry(inquiry.partnerContactInquiryId) }} />
                                                                </td>
                                                            </tr>
                                                        </>)
                                                    })
                                                    : <tr><td colSpan="7">No data found!!!</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div> : loaderApi == false && hasAddPermissionUser == false ? <div className="NoPermission">Don't Have Permisiion</div> : <div className="loaderApi">
                                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                    <g fill="none" fill-rule="evenodd">
                                        <g transform="translate(1 1)" stroke-width="2">
                                            <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                            <path d="M36 18c0-9.94-8.06-18-18-18">
                                                <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                            </path>
                                        </g>
                                    </g>
                                </svg>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
            <div className={`popupWrapperImage ${showImgPopup === true ? 'd-flex' : 'd-none'}`}>
                <div className="crossPopup" onClick={() => {
                    setShowImgPopup(false);
                    setImageContentShow('');
                }}>
                    <RxCross1 />
                </div>
                <div className="contentShowPopup">
                    <h5>Details</h5>
                    {imageContentShow}
                </div>
            </div>
        </DashboardWrapper>
    )
}

export default DashboardPartnerInquires;